// Full-document render of the expired-login-token view: PageSkeleton (the React
// document shell) wrapping the shared ExpiredTokenBody, with tempurpedic's
// utility-page ContentTitle ("Have a question about delivery?") in place of the
// account AccountContentTitle.
import React from "react";
import { ExpiredTokenBody } from "tsi-common-react/src/apps/customer-account/ExpiredTokenBody/index";

import { templates } from "@reactivated";

import { ContentTitle } from "../components/ContentTitle";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.ExpiredTokenDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <ExpiredTokenBody
                {...props}
                titleBar={
                    <ContentTitle
                        title={props.content_title}
                        phoneHref={props.phone_href}
                        phoneDisplay={props.phone_display}
                    />
                }
            />
        </PageSkeleton>
    );
};
